import { useCallback, useEffect } from 'react'
import lodash from 'lodash'
import { useLocation } from 'react-router-dom'

import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import useMyhouse from '@Hooks/myhouse/useMyhouse'
import { FETCH_STATUS } from '@Root/contants'
import useUser from '@Hooks/user/useUser'

const usePreload = () => {
  const location = useLocation()
  const path = location.pathname

  const { user } = useUser()

  const { myhouse, loadMyHouseAuth } = useMyhouse()

  useEffect(() => {
    if (lodash.includes(path, LAND_SERVICE_PREFIX_URL.MYHOUSE) && user.isLogin) {
      if (myhouse.fetchStatus === FETCH_STATUS.INITIAL) {
        loadMyHouseAuth()
      }
    }
  }, [myhouse])

  return {}
}

export default usePreload
